export default __webpack_public_path__ + "static/media/gallery-10-4.73576a73.webp";